module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-home",
    class: {
      'pages-home--drawer': _vm.$store.state.drawer
    }
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.loading),
      expression: "$store.state.loading"
    }]
  }), _c('Navigation'), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "fullpage-container"
  }, [_c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "home",
    staticClass: "fullpage-wp"
  }, [_c('div', {
    staticClass: "page"
  }, [_c('Hero', {
    attrs: {
      "props": _vm.props.acf.hero
    }
  })], 1), _c('div', {
    staticClass: "page"
  }, [_c('Welcome')], 1), _c('div', {
    staticClass: "page"
  }, [_c('About')], 1), _c('div', {
    staticClass: "page"
  }, [_c('Testimonials')], 1), _c('div', {
    staticClass: "page"
  }, [_c('Why')], 1), _c('div', {
    staticClass: "page"
  }, [_c('Treatments')], 1), _c('div', {
    staticClass: "page"
  }, [_c('Contact')], 1)]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.$store.state.showModal) ? _c('Modal', {
    attrs: {
      "props": _vm.props.acf.modal
    }
  }) : _vm._e()], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.$store.state.showOffice) ? _c('OfficeModal', {
    attrs: {
      "props": _vm.props.acf.office
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63753a54","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/home/home.pug
// module id = 540
// module chunks = 1